import React from "react";
import { Link } from "gatsby";

const PeopleLink = ({ data }) => {
  const { frontmatter } = data;
  const { title, thumbnail, path, personalWebsite, metaDescription, position, endYear } = frontmatter;

  return (
    <article className="card">
      <a href={personalWebsite || path}>
        {!!thumbnail && (
          <img
            className="people-avatar"
            src={thumbnail}
            alt={`${title} - Featured Shot`}
          />
        )}
      </a>
      <header>
        <h2 className="post-title">
          <a href={personalWebsite || path} className="post-link">
            {title}
          </a>
        </h2>
        {position !== "alumni" ? (
          <div className="post-meta" dangerouslySetInnerHTML={{ __html: `${metaDescription}` }}></div>
        ) : (
          <div className="post-meta" dangerouslySetInnerHTML={{ __html: `${metaDescription}` }}>
          </div>
        )}
      </header>
    </article>
  );
};

export default PeopleLink;
